import { Building2, ChartLine, HardHat, Truck, Users, Wrench } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

const INDUSTRY_ICONS = {
  'Construction and Engineering': HardHat,
  'Field Services': Truck,
  'Multi-Site Employers': Building2,
  'Maintenance and Facilities': Wrench,
  'Growing SMEs': ChartLine,
  'Labour-Intensive Businesses': Users,
};

// Section 11 — who Pulse is for. Only industries the platform genuinely
// supports; no "suitable for every employer" claims.
export const PulseIndustries = ({ sp }) => (
  <section aria-labelledby="pulse-industries-heading" data-testid="pulse-industries" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="11"
        eyebrow="Who It's For"
        title="Built for businesses managing people across customers, sites and projects"
        testid="pulse-industries-header"
      />
      <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {(sp.industries || []).map((industry, i) => {
          const Icon = INDUSTRY_ICONS[industry.title] || Users;
          return (
            <Reveal key={industry.title} delay={(i % 3) * 0.06} className="h-full">
              <li className="flex h-full flex-col rounded-xl border border-slate-200 bg-mist p-6" data-testid={`pulse-industry-${i + 1}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-navy-900 text-gold-500">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-4 text-base font-extrabold tracking-tight text-navy-900">{industry.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{industry.text}</p>
              </li>
            </Reveal>
          );
        })}
      </ul>
    </div>
  </section>
);
